<template>
  <div>
    <ResumeForm
      :formLine="formLine"
      :data="language"
      ref="form"
    >
    </ResumeForm>
  </div>
</template>

<script>
import _ from 'lodash'
import ResumeForm from '@/components/mobile/resumeForm.vue'
import { validateThreeDigitIntegerTwoDigitDecimalForVant } from '@/utils/validator'

export default {
  components: {
    ResumeForm
  },
  props: {
    language: {
      type: Object,
      required: true
    },
    setting: {
      type: Object,
      default: null
    },
    languageOptions: {
      type: Array,
      default: null
    },
    levelOptions: {
      type: Array,
      default: null
    },
    certificationOptions: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      isShowLanguageScore: false
    }
  },
  computed: {
    languageRequiredField () {
      return this.setting?.languageRequiredField || []
    },
    languageHiddenField () {
      return this.setting?.languageHiddenField || []
    },
    languageDisabledField () {
      return this.setting?.languageDisabledField || []
    },
    formLine () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      const languageRequiredField = []
      if (!_.isEmpty(this.languageRequiredField)) {
        languageRequiredField.push(...this.languageRequiredField)
      }
      const languageHiddenField = []
      if (!_.isEmpty(this.languageHiddenField)) {
        languageHiddenField.push(...this.languageHiddenField)
      }
      const languageDisabledField = []
      if (!_.isEmpty(this.languageDisabledField)) {
        languageDisabledField.push(...this.languageDisabledField)
      }
      return [
        {
          elType: 'select',
          name: 'language',
          hidden: languageHiddenField.includes('language'),
          disabled: languageDisabledField.includes('language'),
          options: { data: this.languageOptions },
          handler: () => {
            this.checkLanguageLevel()
          },
          label: this.$t(`${this.i18nPrefix}.label.language`),
          rules: [{ required: languageRequiredField.includes('language'), message: requiredMessage, trigger: 'blur' }]
        },
        {
          elType: 'select',
          name: 'level',
          hidden: languageHiddenField.includes('level'),
          disabled: languageDisabledField.includes('level'),
          notSearch: true,
          options: { data: this.levelOptions },
          handler: () => {
            this.checkLanguageLevel()
          },
          label: this.$t(`${this.i18nPrefix}.label.level`),
          rules: [{ required: languageRequiredField.includes('level'), message: requiredMessage, trigger: 'blur' }]
        },
        {
          elType: 'select',
          name: 'certification',
          hidden: this.isShowLanguageScore || languageHiddenField.includes('certification'),
          disabled: languageDisabledField.includes('certification'),
          options: { data: this.certificationOptions },
          label: this.$t(`${this.i18nPrefix}.label.certification`),
          rules: [{ required: languageRequiredField.includes('certification'), message: requiredMessage, trigger: 'blur' }]
        },
        {
          elType: 'input',
          name: 'score',
          hidden: this.isShowLanguageScore || languageHiddenField.includes('score'),
          disabled: languageDisabledField.includes('score'),
          label: this.$t(`${this.i18nPrefix}.label.score`),
          rules: [{ required: languageRequiredField.includes('score'), message: requiredMessage, trigger: 'blur' }, { validator: this.validateLanguageScore, message: this.$t('common.message.invalidNumber'), trigger: 'change' }]
        }
      ]
    }
  },
  methods: {
    validateLanguageScore (value, rule) {
      const result = validateThreeDigitIntegerTwoDigitDecimalForVant(value)
      if (result.msg) {
        rule.message = result.msg
      }
      return result.valid
    },
    async submit () {
      const form = await this.getFrom()
      if (form) {
        const result = await form.submit()
        return result
      }
      return false
    },
    checkLanguageLevel () {
      const language = this.language?.language
      const level = this.language?.level
      if (language === 'ENG' && level !== 'NAT') {
        this.isShowLanguageScore = false
      } else {
        this.isShowLanguageScore = true
      }
    },
    async getFrom () {
      let form = this.$refs.form
      if (!form) {
        this.$nextTick()
        form = this.$refs.form
      }
      return form
    }
  },
  watch: {
    language: {
      immediate: true,
      deep: true,
      handler () {
        this.checkLanguageLevel(this.language)
      }
    }
  }
}
</script>

<style>

</style>
